import ChevronRight from '@mui/icons-material/ChevronRight';
import PropTypes from 'prop-types';

import { FormattedMessage } from '@zenbusiness/application-commons-intl';
import Stack from '@zenbusiness/zui/Stack';
import Text from '@zenbusiness/zui/Text';

import * as Styled from './OrderTracker.styles';

function OrderTrackerItem({
  color,
  ctaMessageId,
  eventCallback,
  eventObject,
  justifyContent = 'space-between',
  onClick,
  titleMessageId,
  titleMessageSuffix = '',
  type
}) {
  const eventFnc = eventCallback({
    ...eventObject,
    elementText: type,
    elementValue: type
  });

  const handleOnClick = () => {
    eventFnc();

    if (onClick) {
      onClick();
    }
  };

  return (
    <Styled.StyledOrderTrackerItem display="flex" justifyContent={justifyContent} width="100%" padding="1rem" onClick={handleOnClick}>
      <Text weight="medium" paddingRight="1rem">
        <FormattedMessage
          id={titleMessageId}
        />
        {titleMessageSuffix}
      </Text>
      <Stack direction="row" alignItems="center" spacing={1}>
        <Styled.StyledChip
          color={color}
        >
          <FormattedMessage id={ctaMessageId} />
        </Styled.StyledChip>
        <ChevronRight />
      </Stack>
    </Styled.StyledOrderTrackerItem>
  );
}

OrderTrackerItem.propTypes = {
  color: PropTypes.string.isRequired,
  ctaMessageId: PropTypes.string.isRequired,
  eventCallback: PropTypes.func.isRequired,
  eventObject: PropTypes.shape({}),
  justifyContent: PropTypes.string,
  onClick: PropTypes.func,
  titleMessageId: PropTypes.string.isRequired,
  titleMessageSuffix: PropTypes.string,
  type: PropTypes.string.isRequired
};

export default OrderTrackerItem;
